import { makeStyles } from '@material-ui/core/styles';
import {
  dark as darkColors,
  light as lightColors
} from 'shared/theme/colorTokens';

/**
 * Estilos MUI (outlined) de los pickers del sistema, para que se vean igual
 * que `inputClass` (mismo radio, fondo y borde por tema). Compartido por
 * `StyledDatePicker` y `StyledDateTimePicker`.
 */
export const useStyledFieldStyles = makeStyles((theme) => {
  const isDark = theme.palette.type === 'dark';
  const colors = isDark ? darkColors : lightColors;
  return {
    field: {
      '& .MuiOutlinedInput-root': {
        borderRadius: 8,
        backgroundColor: colors.surface,
        '& fieldset': {
          borderColor: colors.border
        },
        '&:hover fieldset': {
          borderColor: colors.borderHover
        },
        '&.Mui-focused fieldset': {
          borderColor: lightColors.accent,
          borderWidth: 1
        }
      },
      '& .MuiInputBase-input': {
        color: colors.textPrimary,
        fontSize: 14
      },
      '& .MuiIconButton-root': {
        color: colors.textSecondary
      }
    }
  };
});
